import Main from "./Main.js";
import Scene from "./Scene.js";

export default class AddHotspot {
	constructor(callback, payload) {
		this.callback = callback;
		this.payload = payload;
	}


	init() {
		//console.log("AddHotspot")
		// apre il layer con l'iframe
		let mc = jQuery("#template-add-hotspot").clone();
		mc.attr("id", "ifadd" + AddHotspot.ENUM++);
		jQuery(".js-trix1010").append(mc);
		jQuery(".js-close-frame", mc).on("click", jQuery.proxy(this.closeFrame, this, false));
		this.mc = mc;
		this.createAlert();
		Main.showInterface(false);

	}

	closeFrame(lAdded, e) {
		this.mc.remove();
		Main.showInterface(true);
		Main.sfoca(false);
		this.callback.call(null, lAdded);
	}

	createAlert() {
		Main.sfoca(true);
		let content = jQuery(".js-trix-content", this.mc);
		jQuery(".js-image-hs", this.mc).attr("src", this.payload.bd);
		jQuery(".js-btn-aggiungi", this.mc).on("click", jQuery.proxy(this.clickedAggiungi, this));
		jQuery(".js-note", this.mc).on("change propertychange input paste blur", jQuery.proxy(this.checkSubmit, this));
		this.checkSubmit();
	}

	checkSubmit() {
		let note = jQuery(".js-note", this.mc).val();
		if (jQuery.trim(note) == "") {
			jQuery(".js-btn-aggiungi", this.mc).css({ opacity: 0.5, "pointer-events": "none" })
		} else {
			jQuery(".js-btn-aggiungi", this.mc).css({ opacity: 1, "pointer-events": "all" })
		}
	}
	clickedAggiungi() {
		let tipo = jQuery(".js-tipo", this.mc).val();
		let note = jQuery(".js-note", this.mc).val();
		let datiForm = {};
		let scene = Scene.getCurrentScene();
		let tmp = tipo.split("|");
		datiForm.scene = scene.name;
		datiForm.tipo = tmp[0];
		datiForm.testo_it = note;
		datiForm.attiva = true;
		datiForm.ath = this.payload.ath;
		datiForm.atv = this.payload.atv - AddHotspot.COSTANTE_VERTICALE;
		datiForm.bitmap = this.payload.bd;
		datiForm.InfoJson = { hlookat: this.payload.hlookat, vlookat: this.payload.vlookat };
		datiForm.kind = tmp[1];
		jQuery(".js-btn-aggiungi", this.mc).css("opacity", 0.2);
		jQuery(".js-btn-aggiungi", this.mc).css("pointer-events", "none");
		jQuery(".js-disabler").show();
		jQuery(".js-invio").show();
		jQuery(".js-error").hide();


		try {
			window.parent._hotSpotCmsHandler("save", datiForm, jQuery.proxy(this.onSendFormResponseError, this))
		} catch (e) {
			console.log("SALVO HOTSPOT")
			console.log(datiForm);
			setTimeout(jQuery.proxy(this.onSendFormResponseError, this, false), 200);
		}


		/*
		$.ajax({
			type: "POST",
			url: "/rest/add.hotspot",
			data: datiForm,
			dataType: "json",
			complete: jQuery.proxy(this.onSendFormResponse, this)
		});
		*/
	}

	onSendFormResponseError(bSuccess) {
		jQuery(".js-error").show();
		jQuery(".js-btn-aggiungi", this.mc).css("opacity", 1);
		jQuery(".js-btn-aggiungi", this.mc).css("pointer-events", "all");
		jQuery(".js-disabler").hide();
		jQuery(".js-invio").hide();

		/*
		var rs = response ? response.responseJSON : { Success: false, error: "Server.ERROR", error_description: "", error_fatal: "", error_reason: "" };
	
		rs.Success = true;
	
		if (rs.Success) {
			this.closeFrame(true, null);
		} else {
			jQuery(".js-error").show();
		}
		*/
	}

}
AddHotspot.ENUM = 0;
AddHotspot.COSTANTE_VERTICALE = 2.4;
